import { ReactNode, useCallback, useMemo, useState } from 'react';
import { MainHeader, MainMenuSlider } from './components';
import { useLocation } from 'react-router';
import Paths from 'src/paths';

export default function MainLayout({ children }: { children?: ReactNode }) {
  const [menuVisible, setMenuVisible] = useState<boolean>(false);
  const currentPaths = useLocation();

  const onInvisibleMenu = useCallback((value: boolean) => {
    setMenuVisible(value);
  }, []);

  const isHideLayoutSpace =
    currentPaths.pathname === Paths.routes.game.sport ||
    currentPaths.pathname === Paths.routes.game.casino?.root ||
    currentPaths.pathname === Paths.routes.game.fishing.play;
  // currentPaths.pathname === Paths.routes.game.casino.info;

  const isHiddenLayout = useMemo(() => {
    return currentPaths.pathname.includes('/game/fishing/play/');
  }, [currentPaths]);

  return (
    <div className="bg-background max-h-screen min-h-screen overflow-hidden">
      {isHiddenLayout ? '' : <MainHeader onChangeMenuVisible={() => setMenuVisible(i => !i)} />}
      <div
        className={`lg:flex-row ${
          isHiddenLayout
            ? 'min-h-[calc(100vh] md:min-h-[calc(100vh)]'
            : 'min-h-[calc(100vh-2.5rem)] md:min-h-[calc(100vh-2.75rem)]'
        }`}>
        {isHiddenLayout ? (
          ''
        ) : (
          <div
            onClick={() => onInvisibleMenu(false)}
            className={`fixed z-[100] ${
              menuVisible ? 'flex' : 'hidden'
            } lg:flex top-0 lg:relative h-full w-screen lg:w-auto max-h-screen lg:max-h-[calc(100vh-2.75rem)] bg-[#00000078] lg:bg-none`}>
            <MainMenuSlider isFullWidth={menuVisible} onInvisibleMenu={onInvisibleMenu} />
          </div>
        )}
        <div
          className={`min-w-full ${
            menuVisible
              ? isHiddenLayout
                ? 'lg:min-w-[calc(100vw)]'
                : 'lg:min-w-[calc(100vw-14rem)]'
              : isHiddenLayout
                ? 'lg:min-w-[calc(100vw)]'
                : 'lg:min-w-[calc(100vw-3.15rem)]'
          } max-h-max min-h-full overflow-y-auto ${isHideLayoutSpace ? 'p-0' : 'p-1'}`}>
          {children}
        </div>
      </div>
    </div>
  );
}
